/**
 * `usePreferences` — the reader's settings, re-rendered on every change.
 *
 * Every consumer reads the same store, so the theme toggle, the rail and a
 * table's column picker can never disagree about a setting, and a server
 * answer reaches all of them in one render. Change a setting with
 * `updatePreferences` from `src/lib/preference-store.ts`.
 */

import { useSyncExternalStore } from 'react'

import {
  getPreferences,
  subscribePreferences,
  type ViewerPreferences
} from '../lib/preference-store.ts'

/**
 * Read the reader's settings.
 *
 * @returns The settings in force.
 */
export function usePreferences(): ViewerPreferences {
  // The third argument is the server snapshot. This app never renders on a
  // server, and the cache is the right answer if it ever did.
  return useSyncExternalStore(
    subscribePreferences,
    getPreferences,
    getPreferences
  )
}
